module.exports = __webpack_public_path__ + "static/noticias-14--0ba11260cdcc4b2a46f3d30ff40b6209.jpg";